export function isGettingStartedExperimentDisplayed(user: User | undefined) {
    const isExperimentDisplayed = (user &&
        user.experiments?.some(experiment =>
            experiment.experiment === 'abtest_6.12.20_getting_started_experiment' &&
            experiment.bucket === 'show_button') ||
        (window && window.location.href.includes('show_getting_started_experiment'))
    );
    return isExperimentDisplayed;
}
